import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Player from './Player';

const VideoPlayerPopup = ({videoURL}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="e-school-env-btn" onClick={handleShow}>
        <i className="fi fi-rr-play"></i>
      </div>
      <Modal show={show} onHide={handleClose} className="v-player-modal-main">
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body><Player videoURL={videoURL} /></Modal.Body>
      </Modal>
    </>
  )
}

export default VideoPlayerPopup